import React, { useEffect, useState } from "react";
import unsplash from "../../api/unsplash";
import {
  DataGridPro,
  itIT,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "../../utils/PersistedDataGridPro";
import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment as DateAdapter } from "@mui/x-date-pickers/AdapterMoment";

import {
  Edit,
  Delete,
  Add,
  Check,
  Close,
  CheckCircle,
  Error,
  History,
  AttachFile,
  CloudUpload,
  Download,
  Visibility,
} from "@mui/icons-material";
import {
  TextField,
  Button,
  Box,
  Autocomplete,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Zoom,
  LinearProgress,
  Tooltip,
  Badge,
  Typography,
} from "@mui/material";
import GlobalSnackbar from "../Snackbar";
import moment from "moment";
import { CustomFooterPersonalized } from "../../utils/CustomFooterPersonalized";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const actionButtonSx = {
  p: 0.35,
  mx: 0.1,
};

const actionIconStyle = {
  height: "1.55rem",
  width: "1.55rem",
};

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <GridToolbarQuickFilter placeholder="Cerca..." />
      </Grid>
    </GridToolbarContainer>
  );
}
const AdempimentiCliente = (props) => {
  const [adempimenti, setAdempimenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categorieAdempimenti, setCategorieAdempimenti] = useState([]);
  const [elencoAdempimenti, setElencoAdempimenti] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });

  const getDataScadenza = (adempimento) => {
    if (!adempimento.UltimaScadenza || !Number(adempimento.Scadenza)) {
      return "";
    }

    return moment(adempimento.UltimaScadenza)
      .add(Number(adempimento.Scadenza), "M")
      .format("DD/MM/YYYY");
  };

  const columns = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      hide: false,
      width: 190,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            gap: 0.25,
            height: "100%",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <ModalAdd
            selezionato={params.row.ID}
            cliente={props.idAzienda}
            addAdempimento={addAdempimento}
            howTo={params.row.IstruzioniCompilazione}
          />
          <ModalEdit
            check={false}
            selezionato={params.row}
            cliente={props.idAzienda}
            sede={props.sede}
            editAdempimento={editAdempimento}

            //  handleSaving(operazione, mansione, after, before)
          />
          <ModalStorico
            check={false}
            categoria={params.row.Categoria}
            selezionato={params.row.ID}
            cliente={props.idAzienda}
            sede={props.sede}
            setSnack={setSnack}
            setOpenSnack={setOpenSnack}
            loadAdempimenti={loadAdempimenti}
            uploadAdempimentoEffettuatoFiles={uploadAdempimentoEffettuatoFiles}
            //  handleSaving(operazione, mansione, after, before)
          />
          <ModalDelete
            check={false}
            selezionato={params.row}
            cliente={props.idAzienda}
            sede={props.sede}
            deleteAdempimento={deleteAdempimento}
            //  handleSaving(operazione, mansione, after, before)
          />
        </Box>
      ),
    },
    {
      field: "",
      headerName: "Stato",
      width: 70,
      renderCell: (params) => {
        let scadenza = params.row.Scadenza;
        if (scadenza == 0 && params.row.UltimaScadenza) {
          return <CheckCircle sx={{ color: "#40C18F" }} />;
        } else if (!params.row.UltimaScadenza) {
          return <Error sx={{ color: "#FF2768" }} />;
        } else {
          let dateTemp = moment(params.row.UltimaScadenza).add(scadenza, "M");

          if (
            dateTemp.format("YYYY-MM-DD") <
            moment(new Date()).format("YYYY-MM-DD")
          ) {
            return <Error sx={{ color: "#FF2768" }} />;
          } else {
            return <CheckCircle sx={{ color: "#40C18F" }} />;
          }
        }
      },
    },
    { field: "Categoria", headerName: "Categoria", width: 150 },
    { field: "Descrizione", headerName: "Descrizione", flex: 1 },
    { field: "Scadenza", headerName: "Validità", width: 90 },
    {
      field: "UltimaScadenza",
      headerName: "Data",
      width: 90,
      renderCell: (params) =>
        params.row.UltimaScadenza
          ? moment(params.row.UltimaScadenza).format("DD/MM/YYYY")
          : "",
    },
    {
      field: "DataScadenza",
      headerName: "Scadenza",
      width: 110,
      valueGetter: (params) => getDataScadenza(params.row),
    },
  ];

  useEffect(async () => {
    //carico le mansioni del cliente

    let responseAdempimenti = await unsplash.get("adempimenti", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { id: props.idAzienda, sede: props.sede },
    });

    await setAdempimenti(responseAdempimenti.data.data);
    setLoading(false);
    let responseAdempimentiElenco = await unsplash.get("adempimenti", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    setElencoAdempimenti(responseAdempimentiElenco.data.data);

    let responseCategorieAdempimenti = await unsplash.get("adempimenti", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { categoria: true },
    });

    setCategorieAdempimenti(responseCategorieAdempimenti.data.data);
  }, []);

  const uploadAdempimentoEffettuatoFiles = async (
    files,
    idEffettuato,
    adempimento,
  ) => {
    if (!files?.length || !idEffettuato) {
      return;
    }

    const formData = new FormData();
    formData.append("colonna", "AdempimentoEffettuato");
    formData.append("ID", idEffettuato);
    formData.append("colonnaExtra", "Adempimento");
    formData.append("extra", adempimento);
    formData.append("colonnaExtra2", "Cliente");
    formData.append("extra2", props.idAzienda);
    formData.append("colonnaExtra3", "Sede");
    formData.append("extra3", props.sede);
    files.forEach((file) => {
      formData.append("file", file);
    });

    await unsplash.post("caricaDoc", formData, {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
  };

  const handleSaving = async (adempimento, operazione, categoria, storico) => {
    if (operazione === "Inserimento") {
      if (!adempimento) {
        setSnack({
          severity: "error",
          messaggio: "Seleziona un adempimento",
        });
        setOpenSnack(true);
        return false;
      }

      try {
        let adempTemp = {
          Adempimento: adempimento.ID,
          Scadenza: adempimento.Cadenza ? adempimento.Cadenza : 0,
        };
        const note = storico?.note?.trim() ? storico.note.trim() : null;
        const data = storico?.data || null;
        const files = storico?.files || [];

        await unsplash.post(
          "adempimenti",
          {
            adempimento: adempTemp,
            cliente: props.idAzienda,
            sede: props.sede,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );

        if (data || note || files.length > 0) {
          const responseEffettuato = await unsplash.post(
            "adempimenti",
            {
              adempimento: adempimento.ID,
              data: data,
              cliente: props.idAzienda,
              sede: props.sede,
              note: note,
              effettuato: true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwt")}`,
              },
            },
          );
          await uploadAdempimentoEffettuatoFiles(
            files,
            responseEffettuato.data?.message?.insertId,
            adempimento.ID,
          );
        }

        let responseAdempimenti = await unsplash.get("adempimenti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: { id: props.idAzienda, sede: props.sede },
        });

        await setAdempimenti(responseAdempimenti.data.data);
        setSnack({
          severity: "success",
          messaggio: "Adempimento inserito con successo",
        });
        setOpenSnack(true);
        return true;
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante l'inserimento",
        });
        setOpenSnack(true);
        return false;
      }
    }
    return false;
  };

  const addAdempimento = async (data, adempimento, note, files = []) => {
    try {
      const responseEffettuato = await unsplash.post(
        "adempimenti",
        {
          adempimento: adempimento,
          data: data,
          cliente: props.idAzienda,
          sede: props.sede,
          note: note,
          effettuato: true,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );
      await uploadAdempimentoEffettuatoFiles(
        files,
        responseEffettuato.data?.message?.insertId,
        adempimento,
      );

      let responseAdempimenti = await unsplash.get("adempimenti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.idAzienda, sede: props.sede },
      });

      await setAdempimenti(responseAdempimenti.data.data);
      setSnack({
        severity: "success",
        messaggio: "Adempimento inserito con successo",
      });
      setOpenSnack(true);
      return true;
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'inserimento",
      });
      setOpenSnack(true);
      return false;
    }
  };

  const editAdempimento = async (adempimento) => {
    try {
      await unsplash.put(
        "adempimenti",
        { adempimento: adempimento, updateRel: true },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );

      let responseAdempimenti = await unsplash.get("adempimenti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.idAzienda, sede: props.sede },
      });

      await setAdempimenti(responseAdempimenti.data.data);
      setSnack({
        severity: "success",
        messaggio: "Adempimento modificato con successo",
      });
      setOpenSnack(true);
      return true;
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'inserimento",
      });
      setOpenSnack(true);
      return false;
    }
  };

  const loadAdempimenti = async () => {
    let responseAdempimenti = await unsplash.get("adempimenti", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { id: props.idAzienda, sede: props.sede },
    });

    await setAdempimenti(responseAdempimenti.data.data);
  };

  const deleteAdempimento = async (adempimento) => {
    try {
      await unsplash.delete("adempimenti", {
        headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
        data: { adempimento: adempimento, updateRel: true },
      });

      let responseAdempimenti = await unsplash.get("adempimenti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.idAzienda, sede: props.sede },
      });

      await setAdempimenti(responseAdempimenti.data.data);
      setSnack({
        severity: "success",
        messaggio: "Adempimento eliminato con successo",
      });
      setOpenSnack(true);
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'inserimento",
      });
      setOpenSnack(true);
    }
  };

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid
        container
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="flex-end"
      >
        <Modal
          check={true}
          title="Associa"
          tipologia="Inserimento"
          elencoAdempimenti={elencoAdempimenti}
          adempimenti={adempimenti}
          categorieAdempimenti={categorieAdempimenti}
          selezionata="NO"
          cliente={props.idAzienda}
          saveFunction={handleSaving}
        />
      </Grid>
      <Box sx={{ height: "60vh", width: 1 }}>
        <DataGridPro
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          components={{
            Toolbar: CustomToolbar,
            Footer: CustomFooterPersonalized,
          }}
          slots={{
            loadingOverlay: LinearProgress,
          }}
          loading={loading}
          rows={adempimenti}
          getRowId={(adempimenti) => adempimenti.ID}
          columns={columns}
          initialState={{ pinnedColumns: { left: ["Actions"] } }}
          disableSelectionOnClick
        />
      </Box>
    </>
  );
};

//MODAL
const Modal = (props) => {
  const [open, setOpen] = useState(false);
  const [adempimentoSel, setAdempimentoSel] = useState(null);
  const [categoriaSel, setCategoriaSel] = useState(false);
  const [adempimenti, setAdempimenti] = useState([]);
  const [adempimentiBackup, setAdempimentiBackup] = useState([]);
  const [date, setDate] = useState(null);
  const [note, setNote] = useState("");
  const [files, setFiles] = useState([]);
  const noteAdempimento = adempimentoSel?.IstruzioniCompilazione?.trim();

  const handleClickOpen = () => {
    let ad = getDifference(
      props.elencoAdempimenti,
      props.adempimenti,
      "ID",
      "ID",
    );
    setAdempimentoSel(null);
    setAdempimenti(ad);
    setAdempimentiBackup(ad);
    setCategoriaSel(null);
    setDate(null);
    setNote("");
    setFiles([]);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    const saved = await props.saveFunction(
      adempimentoSel,
      props.tipologia,
      categoriaSel,
      { data: date, note: note, files: files },
    );

    if (!saved) {
      return;
    }

    let ad = getDifference(adempimentiBackup, [adempimentoSel], "ID", "ID");

    setAdempimenti(
      ad.filter((v) => v.CategoriaAdempimento === categoriaSel.ID),
    );
    setAdempimentiBackup(ad);
    setAdempimentoSel(null);
    setDate(null);
    setNote("");
    setFiles([]);
    handleClose();
  };

  return (
    <div>
      <Button
        startIcon={<Add />}
        variant="contained"
        onClick={handleClickOpen}
        id={props.id}
        className="ButtonMiller"
      >
        Associa
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DialogTitle>Associa</DialogTitle>
        <DialogContent sx={{ pt: 2.5 }}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                id="combo-box-demo"
                options={props.categorieAdempimenti}
                getOptionLabel={(option) => option.Descrizione}
                fullWidth
                onChange={(event, newValue) => {
                  if (newValue) {
                    setAdempimenti(
                      adempimentiBackup.filter(
                        (v) => v.CategoriaAdempimento === newValue.ID,
                      ),
                    );
                    setCategoriaSel(newValue);
                    setAdempimentoSel(null);
                  } else {
                    setAdempimenti(adempimentiBackup);
                    setCategoriaSel(false);
                    setAdempimentoSel(null);
                  }
                  //handleChangeCliente(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth label="Categoria" />
                )}
                sx={{ mt: 1 }}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Autocomplete
                style={{ display: categoriaSel ? "" : "None" }}
                id="combo-box-demo"
                options={adempimenti}
                getOptionLabel={(option) => option.Descrizione}
                fullWidth
                value={adempimentoSel}
                onChange={(event, newValue) => {
                  setAdempimentoSel(newValue);
                  //handleChangeCliente(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth label="Adempimento" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                style={{ display: categoriaSel ? "" : "None" }}
                value={adempimentoSel?.Cadenza ?? ""}
                name="Scadenza"
                label="Scadenza"
                type="number"
                fullWidth
                disabled={!adempimentoSel}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  let a = { ...adempimentoSel };
                  a.Cadenza = e.target.value;
                  setAdempimentoSel(a);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <DatePicker
                  ampmInClock={false}
                  renderInput={(props) => <TextField {...props} fullWidth />}
                  label="Data effettuazione"
                  value={date ? moment(date) : null}
                  onChange={(newValue) => {
                    setDate(newValue ? newValue.format("YYYY-MM-DD") : null);
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={note}
                name="Note"
                label="Note"
                type="text"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                onChange={(e) => setNote(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFile />}
                className="ButtonMiller"
              >
                Allegato
                <input
                  hidden
                  type="file"
                  multiple
                  onChange={(event) =>
                    setFiles(Array.from(event.target.files || []))
                  }
                />
              </Button>
              {files.length > 0 && (
                <Typography sx={{ mt: 1 }} variant="body2">
                  {files.map((file) => file.name).join(", ")}
                </Typography>
              )}
            </Grid>
            {noteAdempimento && (
              <Grid item xs={12}>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 0.75 }}
                  variant="subtitle2"
                >
                  Note adempimento
                </Typography>
                <Typography sx={{ whiteSpace: "pre-line" }} variant="body1">
                  {noteAdempimento}
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
          >
            Associa
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ModalAdd = (props) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(null);
  const [note, setNote] = useState("");
  const [files, setFiles] = useState([]);
  const handleClickOpen = () => {
    setDate(null);
    setNote("");
    setFiles([]);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    if (!date && !note?.trim() && files.length === 0) {
      return;
    }

    const saved = await props.addAdempimento(
      date,
      props.selezionato,
      note?.trim() ? note.trim() : null,
      files,
    );

    if (saved) {
      handleClose();
    }
  };

  return (
    <div>
      <IconButton onClick={handleClickOpen} sx={actionButtonSx}>
        <Add style={{ ...actionIconStyle, color: "#2265B1" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DialogTitle>Inserisci nuova Data</DialogTitle>
        <DialogContent style={{ paddingTop: "20px" }}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <DatePicker
                  ampmInClock={false}
                  renderInput={(props) => <TextField {...props} fullWidth />}
                  label="inserisci"
                  value={date ? moment(date) : null}
                  onChange={(newValue) => {
                    setDate(newValue ? newValue.format("YYYY-MM-DD") : null);
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={note}
                name="Note"
                label="Note"
                type="text"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                onChange={(e) => setNote(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFile />}
                className="ButtonMiller"
              >
                Allegato
                <input
                  hidden
                  type="file"
                  multiple
                  onChange={(event) =>
                    setFiles(Array.from(event.target.files || []))
                  }
                />
              </Button>
              {files.length > 0 && (
                <Typography sx={{ mt: 1 }} variant="body2">
                  {files.map((file) => file.name).join(", ")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              {props.howTo}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
            disabled={!date && !note?.trim() && files.length === 0}
          >
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ModalStorico = (props) => {
  const [open, setOpen] = useState(false);
  const [storico, setStorico] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      field: "Actions",
      headerName: "Azioni",
      align: "center",
      headerAlign: "center",
      width: 120,
      renderCell: (params) => (
        <>
          <ModalAllegatiAdempimento
            storico={params.row}
            adempimento={props.selezionato}
            cliente={props.cliente}
            sede={props.sede}
            setSnack={props.setSnack}
            setOpenSnack={props.setOpenSnack}
            loadStorico={loadStorico}
            loadAdempimenti={props.loadAdempimenti}
            uploadAdempimentoEffettuatoFiles={
              props.uploadAdempimentoEffettuatoFiles
            }
          />
          <ModalDeleteAdempimentoStorico
            selezionato={params.row}
            deleteAdempimento={deleteAdempimento}
            //  handleSaving(operazione, mansione, after, before)
          />
        </>
      ),
    },
    {
      field: "Data",
      headerName: "Data",
      align: "center",
      headerAlign: "center",
      width: 130,
      renderCell: (params) =>
        params.row.Data ? moment(params.row.Data).format("DD/MM/YYYY") : "",
    },
    {
      field: "Note",
      headerName: "Note",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => {
        const note = params.row.Note || "";

        return (
          <Tooltip title={note}>
            <span>{note}</span>
          </Tooltip>
        );
      },
    },
  ];
  const loadStorico = async () => {
    setLoading(true);
    try {
      let responseAdempimenti = await unsplash.get("adempimenti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: {
          cliente: props.cliente,
          adempimento: props.selezionato,
          sede: props.sede,
        },
      });
      setStorico(responseAdempimenti.data.data);
    } catch {
      setStorico([]);
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante il caricamento dello storico",
      });
      props.setOpenSnack(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClickOpen = async () => {
    setOpen(true);
    await loadStorico();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteAdempimento = async (adempimento) => {
    try {
      await unsplash.delete("adempimenti", {
        headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
        data: { adempimento: adempimento, updateEffettuato: true },
      });

      await loadStorico();
      props.loadAdempimenti();
      props.setSnack({
        severity: "success",
        messaggio: "Adempimento eliminato con successo",
      });
      props.setOpenSnack(true);
    } catch {
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante l'inserimento",
      });
      props.setOpenSnack(true);
    }
  };

  return (
    <div>
      <IconButton onClick={handleClickOpen} sx={actionButtonSx}>
        <History style={{ ...actionIconStyle, color: "#2265B1" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={"xl"}
        TransitionComponent={Transition}
      >
        <DialogTitle>Storico - {props.categoria}</DialogTitle>
        <DialogContent>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <div style={{ height: 400, width: "100%" }}>
                <DataGridPro
                  style={{ marginTop: "10px" }}
                  localeText={
                    itIT.components.MuiDataGrid.defaultProps.localeText
                  }
                  components={{
                    Toolbar: CustomToolbar,
                    Footer: CustomFooterPersonalized,
                  }}
                  slots={{
                    loadingOverlay: LinearProgress,
                  }}
                  loading={loading}
                  rows={storico}
                  getRowId={(storico) => storico.IDEffettuato}
                  columns={columns}
                  initialState={{ pinnedColumns: { left: ["Actions"] } }}
                  disableSelectionOnClick
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          {/*<Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
          >
            Associa
        </Button>*/}
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ModalAllegatiAdempimento = (props) => {
  const [open, setOpen] = useState(false);
  const [allegati, setAllegati] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [allegatoDaEliminare, setAllegatoDaEliminare] = useState(null);
  const [preview, setPreview] = useState({
    open: false,
    nome: "",
    type: "",
    url: "",
  });

  const getNomeOriginale = (allegato) =>
    allegato.Descrizione?.includes(allegato.Estensione)
      ? allegato.Descrizione
      : allegato.Descrizione + allegato.Estensione;

  const getPreviewType = (estensione) => {
    const extension = String(estensione || "").toLowerCase();

    if (extension === ".pdf") {
      return "pdf";
    }

    if (
      [".jpg", ".jpeg", ".png", ".gif", ".webp", ".bmp"].includes(extension)
    ) {
      return "image";
    }

    if ([".txt", ".csv", ".log"].includes(extension)) {
      return "text";
    }

    return "";
  };

  const getMimeType = (allegato) => {
    const extension = String(allegato.Estensione || "").toLowerCase();

    switch (extension) {
      case ".pdf":
        return "application/pdf";
      case ".jpg":
      case ".jpeg":
        return "image/jpeg";
      case ".png":
        return "image/png";
      case ".gif":
        return "image/gif";
      case ".webp":
        return "image/webp";
      case ".bmp":
        return "image/bmp";
      case ".csv":
        return "text/csv";
      case ".txt":
      case ".log":
        return "text/plain";
      default:
        return "application/octet-stream";
    }
  };

  const fetchAllegatoBlob = async (allegato) => {
    const nomeOriginale = getNomeOriginale(allegato);
    const response = await unsplash.post(
      "ftp",
      {
        file: allegato.ID + allegato.Estensione,
        nomeOriginale,
        operazione: "download",
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        responseType: "blob",
      },
    );

    return {
      blob: new Blob([response.data], {
        type: response.data?.type || getMimeType(allegato),
      }),
      nomeOriginale,
    };
  };

  const loadAllegati = async () => {
    setLoading(true);
    try {
      const response = await unsplash.get("allegati", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: {
          colonna: "AdempimentoEffettuato",
          ID: props.storico.IDEffettuato,
        },
      });
      setAllegati(response.data.data);
    } catch {
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante il caricamento degli allegati",
      });
      props.setOpenSnack(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClickOpen = async () => {
    setFiles([]);
    setOpen(true);
    await loadAllegati();
  };

  const handleClose = () => {
    setOpen(false);
    setAllegatoDaEliminare(null);
  };

  const handleClosePreview = () => {
    if (preview.url) {
      window.URL.revokeObjectURL(preview.url);
    }

    setPreview({
      open: false,
      nome: "",
      type: "",
      url: "",
    });
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      return;
    }

    setUploading(true);
    try {
      await props.uploadAdempimentoEffettuatoFiles(
        files,
        props.storico.IDEffettuato,
        props.adempimento,
      );
      setFiles([]);
      await loadAllegati();
      await props.loadStorico();
      await props.loadAdempimenti();
      props.setSnack({
        severity: "success",
        messaggio: "Allegato caricato con successo",
      });
      props.setOpenSnack(true);
    } catch {
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante il caricamento dell'allegato",
      });
      props.setOpenSnack(true);
    } finally {
      setUploading(false);
    }
  };

  const downloadFile = async (allegato) => {
    try {
      const { blob, nomeOriginale } = await fetchAllegatoBlob(allegato);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nomeOriginale);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch {
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante il download dell'allegato",
      });
      props.setOpenSnack(true);
    }
  };

  const previewFile = async (allegato) => {
    const type = getPreviewType(allegato.Estensione);

    if (!type) {
      setPreview({
        open: true,
        nome: getNomeOriginale(allegato),
        type: "",
        url: "",
      });
      return;
    }

    try {
      const { blob, nomeOriginale } = await fetchAllegatoBlob(allegato);
      const url = window.URL.createObjectURL(blob);
      setPreview({
        open: true,
        nome: nomeOriginale,
        type,
        url,
      });
    } catch {
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante l'apertura dell'anteprima",
      });
      props.setOpenSnack(true);
    }
  };

  const deleteFile = async () => {
    if (!allegatoDaEliminare) {
      return;
    }

    setDeleting(true);
    try {
      await unsplash.post(
        "ftp",
        {
          file: allegatoDaEliminare.ID + allegatoDaEliminare.Estensione,
          operazione: "delete",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );
      await loadAllegati();
      await props.loadStorico();
      await props.loadAdempimenti();
      props.setSnack({
        severity: "success",
        messaggio: "Allegato eliminato con successo",
      });
      props.setOpenSnack(true);
    } catch {
      props.setSnack({
        severity: "error",
        messaggio: "Errore durante l'eliminazione dell'allegato",
      });
      props.setOpenSnack(true);
    } finally {
      setDeleting(false);
      setAllegatoDaEliminare(null);
    }
  };

  const columns = [
    {
      field: "Actions",
      headerName: "Azioni",
      align: "center",
      headerAlign: "center",
      width: 165,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => previewFile(params.row)}>
            <Visibility
              style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
            />
          </IconButton>
          <IconButton onClick={() => downloadFile(params.row)}>
            <Download
              style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
            />
          </IconButton>
          <IconButton onClick={() => setAllegatoDaEliminare(params.row)}>
            <Delete
              style={{ height: "2rem", width: "2rem", color: "#FF2768" }}
            />
          </IconButton>
        </>
      ),
    },
    { field: "Descrizione", headerName: "Documento", flex: 1 },
    { field: "Estensione", headerName: "Tipo", width: 90 },
    {
      field: "DataInserimento",
      headerName: "Caricato il",
      width: 130,
      renderCell: (params) =>
        params.row.DataInserimento
          ? moment(params.row.DataInserimento).format("DD/MM/YYYY")
          : "",
    },
  ];

  return (
    <div>
      <IconButton onClick={handleClickOpen} sx={actionButtonSx}>
        <Badge
          badgeContent={Number(props.storico.NAllegati || 0)}
          color="primary"
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.65rem",
              height: 16,
              minWidth: 16,
            },
          }}
        >
          <AttachFile style={{ ...actionIconStyle, color: "#2265B1" }} />
        </Badge>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        TransitionComponent={Transition}
      >
        <DialogTitle>
          Allegati -{" "}
          {props.storico.Data
            ? moment(props.storico.Data).format("DD/MM/YYYY")
            : "Senza data"}
        </DialogTitle>
        <DialogContent sx={{ pt: 2.5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFile />}
                className="ButtonMiller"
              >
                Seleziona file
                <input
                  hidden
                  type="file"
                  multiple
                  onChange={(event) =>
                    setFiles(Array.from(event.target.files || []))
                  }
                />
              </Button>
              {files.length > 0 && (
                <Typography sx={{ mt: 1 }} variant="body2">
                  {files.map((file) => file.name).join(", ")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ height: 360, width: "100%" }}>
                <DataGridPro
                  localeText={
                    itIT.components.MuiDataGrid.defaultProps.localeText
                  }
                  components={{
                    Toolbar: CustomToolbar,
                    Footer: CustomFooterPersonalized,
                  }}
                  slots={{
                    loadingOverlay: LinearProgress,
                  }}
                  loading={loading}
                  rows={allegati}
                  getRowId={(allegato) => allegato.ID}
                  columns={columns}
                  disableSelectionOnClick
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<CloudUpload />}
            onClick={handleUpload}
            disabled={files.length === 0 || uploading}
          >
            Carica
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(allegatoDaEliminare)}
        onClose={() => {
          if (!deleting) {
            setAllegatoDaEliminare(null);
          }
        }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Rimuovi allegato</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Vuoi eliminare definitivamente{" "}
            {allegatoDaEliminare ? getNomeOriginale(allegatoDaEliminare) : ""}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            disabled={deleting}
            onClick={() => setAllegatoDaEliminare(null)}
          >
            Annulla
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Delete />}
            disabled={deleting}
            onClick={deleteFile}
          >
            Elimina
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={preview.open}
        onClose={handleClosePreview}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>{preview.nome || "Anteprima allegato"}</DialogTitle>
        <DialogContent sx={{ height: "75vh" }}>
          {preview.url && preview.type === "image" && (
            <Box
              component="img"
              src={preview.url}
              alt={preview.nome}
              sx={{
                display: "block",
                height: "100%",
                maxWidth: "100%",
                objectFit: "contain",
                width: "100%",
              }}
            />
          )}
          {preview.url && ["pdf", "text"].includes(preview.type) && (
            <Box
              component="iframe"
              src={preview.url}
              title={preview.nome}
              sx={{
                border: 0,
                height: "100%",
                width: "100%",
              }}
            />
          )}
          {!preview.url && (
            <Typography>
              Anteprima non disponibile per questo formato. Usa il download per
              aprire il file.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3 }}>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClosePreview}
          >
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ModalEdit = (props) => {
  const [open, setOpen] = useState(false);
  const [adempimentoSel, setAdempimentoSel] = useState(null);

  const handleClickOpen = () => {
    setAdempimentoSel(props.selezionato);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    const saved = await props.editAdempimento(adempimentoSel);
    if (saved) {
      handleClose();
    }
  };

  return (
    <div>
      <IconButton onClick={handleClickOpen} sx={actionButtonSx}>
        <Edit style={{ ...actionIconStyle, color: "#2265B1" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DialogTitle>{props.selezionato.Descrizione}</DialogTitle>
        <DialogContent style={{ paddingTop: "20px" }}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <TextField
                value={adempimentoSel ? adempimentoSel.Scadenza : 0}
                name="Scadenza"
                label="Modifica scadenza"
                type="number"
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  let a = { ...adempimentoSel };
                  a.Scadenza = e.target.value;
                  setAdempimentoSel(a);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
          >
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ModalDelete = (props) => {
  const [open, setOpen] = useState(false);
  const [adempimentoSel, setAdempimentoSel] = useState(null);

  const handleClickOpen = () => {
    setAdempimentoSel(props.selezionato);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    props.deleteAdempimento(adempimentoSel);
  };

  return (
    <div>
      <IconButton onClick={handleClickOpen} sx={actionButtonSx}>
        <Delete style={{ ...actionIconStyle, color: "#FF2768" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DialogTitle>Rimuovi Adempimento</DialogTitle>
        <DialogContent style={{ paddingTop: "20px" }}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              Sei sicuro di voler rimuove l'adempimento:{" "}
              {props.selezionato.Descrizione}?
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleDelete}
          >
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ModalDeleteAdempimentoStorico = (props) => {
  const [open, setOpen] = useState(false);
  const [adempimentoSel, setAdempimentoSel] = useState(null);

  const handleClickOpen = () => {
    setAdempimentoSel(props.selezionato);

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    props.deleteAdempimento(adempimentoSel);
  };

  return (
    <div>
      <IconButton onClick={handleClickOpen}>
        <Delete style={{ height: "2rem", width: "2rem", color: "#FF2768" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DialogTitle>Rimuovi Adempimento</DialogTitle>
        <DialogContent style={{ paddingTop: "20px" }}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              Sei sicuro di voler rimuove l'adempimento effettuato in data:{" "}
              {moment(adempimentoSel?.Data).format("DD/MM/YYYY")}, inserito con
              le seguenti note: {adempimentoSel?.Note}?
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            px: 3,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Chiudi
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleDelete}
          >
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdempimentiCliente;

function getDifference(array1, array2, prop1, prop2) {
  //riutilizzabile per differenze tra due array di oggetti
  return array1.filter((object1) => {
    return !array2.some((object2) => {
      return object1[prop1] === object2[prop2];
    });
  });
}
